import React from 'react';
import {
  Card,
  CardBody,
  Heading,
  VStack,
  Text,
  Divider,
  HStack,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Spinner,
  Badge,
  Box
} from '@chakra-ui/react';
import { MdRefresh } from 'react-icons/md';
import {
  VANCE_FX_TABLE_HEADERS,
  getProviderBadgeColor,
  renderCellValue,
  sortCurrencies
} from './utils';

export const VanceFxRatesCard = ({ data, isLoading, onRefresh }) => {
  const currencies = data ? sortCurrencies(Object.keys(data)) : [];

  const renderCell = (key, value, rowData) => {
    if (key === 'effectiveProvider' && value) {
      return (
        <Badge colorScheme={getProviderBadgeColor(value)} fontSize="xs">
          {value}
        </Badge>
      );
    }
    return renderCellValue(key, value, rowData);
  };

  return (
    <Card bg="backGround" borderColor="brand.500" borderWidth="2px" shadow="xl">
      <CardBody>
        <VStack alignItems="stretch" gap={4}>
          <HStack justify="space-between" align="center">
            <Box>
              <Heading size="md" color="colorPrimary">Vance FX Rates</Heading>
              <Text fontSize="xs" color="gray.400">Current FX rates from the Vance service</Text>
            </Box>
            {onRefresh && (
              <Button
                size="sm"
                colorScheme="brand"
                bg="brand.600"
                _hover={{ bg: 'brand.700' }}
                onClick={onRefresh}
                isLoading={isLoading}
                leftIcon={<MdRefresh size="1rem" />}
              >
                Refresh
              </Button>
            )}
          </HStack>
          <Divider borderColor="whiteAlpha.300" />

          {isLoading && !data ? (
            <HStack justify="center" py={8}>
              <Spinner color="brand.500" />
              <Text color="gray.400">Loading rates...</Text>
            </HStack>
          ) : currencies.length === 0 ? (
            <Text color="gray.500" textAlign="center" py={4}>No FX rates data available</Text>
          ) : (
            <TableContainer maxH="500px" overflowY="auto">
              <Table variant="simple" size="sm">
                <Thead position="sticky" top={0} bg="dark.400" zIndex={1}>
                  <Tr>
                    {VANCE_FX_TABLE_HEADERS.map((header) => (
                      <Th
                        key={header.key}
                        color="gray.300"
                        borderColor="whiteAlpha.300"
                        fontSize="xs"
                        textTransform="capitalize"
                        whiteSpace="nowrap"
                      >
                        {header.label}
                      </Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {currencies.map((currency) => {
                    const rowData = data[currency];
                    return (
                      <Tr key={currency} _hover={{ bg: 'dark.500' }}>
                        <Td borderColor="whiteAlpha.200" color="white" fontWeight="bold">
                          {currency}
                        </Td>
                        {VANCE_FX_TABLE_HEADERS.slice(1).map((header) => (
                          <Td
                            key={header.key}
                            borderColor="whiteAlpha.200"
                            color="gray.200"
                            fontSize="sm"
                            whiteSpace="nowrap"
                          >
                            {renderCell(header.key, rowData?.[header.key], rowData)}
                          </Td>
                        ))}
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          )}
        </VStack>
      </CardBody>
    </Card>
  );
};
